import { createStyles, makeStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    moduleCard: {
      padding: theme.spacing(2),

      '&[data-variant=draggableV2]': {
        padding: 0,
        border: `.1rem solid ${variables.colorV2.contentModuleCard.default.border.listing}`,
        borderRadius: '.8rem',
        cursor: 'grab',

        '&:hover': {
          border: `.1rem solid ${variables.colorV2.contentModuleCard.default.border.hover}`,
        },

        '& $coverImage': {
          borderBottom: `.1rem solid ${variables.colorV2.contentModuleCard.default.border.listing}`,
          borderRadius: 'unset',
          padding: 0,
          pointerEvents: 'none',
        },

        '&.dragging-source': {
          //'& $coverImage, & $info, & $action': {
          '& $coverImage, & $action': {
            opacity: 0.5,
          },
        },

        '&.dragging': {
          borderColor: variables.colorV2.contentModuleCard.default.border.hover,
          borderWidth: variables.borderWidth.lg,
        },
      },
    },

    coverImageWrapper: {
      position: 'relative',
      // height: '19.5rem',
      overflow: 'hidden',
      borderRadius: '.8rem',
      // background: variables.color.primary.backgroundLightGray,
    },

    coverImage: {
      width: '100%',
      height: 'auto',
      // position: 'absolute',
    },

    content: {
      padding: theme.spacing(1, 2, 2, 2),
    },

    name: {
      color: variables.colorV2.contentModuleCard.default.text.default,
      marginBottom: theme.spacing(0.5),
      maxWidth: '32rem',
      paddingRight: '0.5rem',
    },

    ctir: {
      minWidth: '6rem',
      textAlign: 'right',
    },

    contentValue: {
      color: variables.colorV2.contentModuleCard.default.text.default,
      fontWeight: 500,
    },

    deploymentName: {
      color: variables.colorV2.contentModuleCard.default.text.default,
      fontWeight: 500,
      textAlign: 'right',
      width: '40%',
    },

    moduleRow: {
      display: 'flex',
      alignItems: 'top',
      justifyContent: 'space-between',
    },

    moduleRow2: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    index: {
      '&&': {
        color: variables.colorV2.contentModuleCard.default.text.default,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        background: variables.colorV2.contentModuleCard.default.background.id,
        borderRadius: '2px',
        width: 'fit-content',
        padding: '2px 5px',
        fontWeight: '700',
        fontSize: '9px',
        cursor: 'pointer',
      },
    },

    dark: {
      color: variables.color.primary.darkestGray,
    },

    tag: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: theme.spacing(1),
      maxWidth: '7.6rem',
    },

    action: {
      display: 'flex',
      alignItems: 'center',
      flex: '0 0 auto',
    },

    actionBtnDrag: {
      padding: theme.spacing(1),
    },

    actionBtnDragV2: {
      padding: theme.spacing(1),
      cursor: 'grab',
    },

    actionBtnResize: {
      padding: theme.spacing(0.5, 1),
    },
  }),
);
